__turbopack_context__.v({
  "PersonalizedContent": "_3oOy8G_PersonalizedContent",
  "toggleSkeletonSimulation": "_3oOy8G_toggleSkeletonSimulation",
});
